function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117 60C117 91.4802 91.4802 117 60 117C28.5198 117 3 91.4802 3 60C3 28.5198 28.5198 3 60 3C91.4802 3 117 28.5198 117 60Z",
  stroke: "white",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 49C49.5 54.799 54.201 59.5 60 59.5C65.799 59.5 70.5 54.799 70.5 49H73.5C73.5 56.4558 67.4558 62.5 60 62.5C52.5442 62.5 46.5 56.4558 46.5 49H49.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M73.5 87.5H81.5V83.5H73.5V87.5Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.93 66.5239C32.9204 69.4793 28 76.415 28 84.5V95H91V84.5C91 76.6848 86.4026 69.9435 79.7647 66.8329C78.0043 66.008 76.1004 65.4384 74.1007 65.1719C75.6706 63.952 77.0782 62.5331 78.2857 60.9531C81.2432 57.0832 83 52.2467 83 47C83 34.2975 72.7025 24 60 24C47.2975 24 37 34.2975 37 47C37 52.1462 38.6901 56.8976 41.5456 60.7295C42.7587 62.3575 44.1821 63.8194 45.7757 65.0752C43.7189 65.2554 41.7537 65.7549 39.93 66.5239ZM69.274 66.4769C68.748 64.5315 69.4414 62.4604 71.0327 61.2238C75.2814 57.9223 78 52.7799 78 47C78 37.0589 69.9411 29 60 29C50.0589 29 42 37.0589 42 47C42 52.736 44.6773 57.8437 48.8704 61.148C50.4807 62.417 51.1531 64.5404 50.5669 66.505C50.4863 66.775 50.3842 67.0344 50.2627 67.2817L60 78.1204L69.6267 67.4047C69.4805 67.1116 69.3617 66.8013 69.274 66.4769ZM80.0054 72.7543L66.0167 88.4916L60 81.8732L53.9833 88.4916L39.6157 72.3281C35.6345 74.9131 33 79.4001 33 84.5V90H86V84.5C86 79.6709 83.6373 75.3901 80.0054 72.7543ZM45.0475 72.418L54.0167 82.5084L56.3043 79.9921L47.8695 70.603L45.0475 72.418ZM65.9833 82.5084L74.9525 72.418L72.1305 70.603L63.6957 79.9921L65.9833 82.5084Z",
  fill: "white"
});

function SvgMainPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPerson);
export default __webpack_public_path__ + "static/media/mainPerson.bf40d796.svg";
export { ForwardRef as ReactComponent };